import React, { PureComponent } from 'react';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import Foot, { Footer } from '../../components/footer';
import SzHeader from '../../components/szHeader';
import Qrcode from '../../components/qrcode';
import Search from '../../components/search';
import LeftNav from '../../components/leftNav';
import RightOne from '../layout/rightOne';
import RightTwo from '../layout/rightTwo';

import RightFive from '../layout/rightFive';
import PropTypes from 'prop-types';
import Chip from 'Chip';
import ChipEdit from 'ChipEdit';

/**
 * for this page
 */

const Layout = errorBoundary(
    class extends PureComponent {
        static propTypes = {
            content: PropTypes.object,
        };
        state = {
            oneDisplay: true,
            twoDisplay: false,
            threeDisplay: false,
            fourDisplay: false,
            fiveDisplay: false,
            navIndex: 0,
        };
        // 左侧导航点击定位
        handleLeftNav = num => {
            if (num === 0) {
                this.setState({
                    oneDisplay: true,
                    twoDisplay: false,
                    threeDisplay: false,
                    fourDisplay: false,
                    fiveDisplay: false,
                });
            } else if (num === 1) {
                this.setState({
                    oneDisplay: false,
                    twoDisplay: true,
                    threeDisplay: false,
                    fourDisplay: false,
                    fiveDisplay: false,
                });
            } else if (num === 2) {
                this.setState({
                    oneDisplay: false,
                    twoDisplay: false,
                    threeDisplay: true,
                    fourDisplay: false,
                    fiveDisplay: false,
                });
            } else if (num === 3) {
                this.setState({
                    oneDisplay: false,
                    twoDisplay: false,
                    threeDisplay: false,
                    fourDisplay: true,
                    fiveDisplay: false,
                });
            } else if (num === 4) {
                this.setState({
                    oneDisplay: false,
                    twoDisplay: false,
                    threeDisplay: false,
                    fourDisplay: false,
                    fiveDisplay: true,
                });
            }
            this.setState({
                navIndex: num,
            });
        };
        handleName = text => {
            console.log('test==', text);

            if (text === undefined) {
                const recruitSearch = window.open('about:blank');

                recruitSearch.location.href = '/pc/career/job/recruit/';
            } else {
                const recruitSearch = window.open('about:blank');

                recruitSearch.location.href = `/pc/career/job/recruit/${text}/`;
            }
        };
        render() {
            const { content } = this.props;

            const { header, qrCodeInfo, leftNav, rightOne, rightTwo, rightThree, rightFour, rightFive } = content;
            const { oneDisplay, twoDisplay, threeDisplay, navIndex, fourDisplay, fiveDisplay } = this.state;

            return (
                <div>
                    <div className={styles.col}>
                        <Search handleName={this.handleName} />
                        <SzHeader current={3} content={header} />
                        <div className={`${styles.mid_gy} clearfix`} style={{ marginBottom: '0' }}>
                            <div className={styles.mid_gy_left}>
                                <Chip id="65004" type="struct" title="左侧导航" groupName="关于凤凰" content={leftNav}>
                                    <LeftNav clickHandle={this.handleLeftNav} current={navIndex} />
                                </Chip>
                            </div>
                            <div className={styles.mid_gy_right}>
                                <Chip id="80035" type="struct" title="工作环境" groupName="人在凤凰" content={rightOne}>
                                    <RightOne show={oneDisplay} />
                                </Chip>
                                <Chip id="40164" type="static" title="薪酬福利" groupName="人在凤凰" content={rightTwo}>
                                    <RightTwo show={twoDisplay} />
                                </Chip>

                                <Chip
                                    id="40120"
                                    type="static"
                                    title="职业发展"
                                    groupName="人在凤凰"
                                    content={rightThree}>
                                    <RightTwo show={threeDisplay} />
                                </Chip>
                                <Chip
                                    id="40121"
                                    type="static"
                                    title="凤凰活动"
                                    groupName="人在凤凰"
                                    content={rightFour}>
                                    <RightTwo show={fourDisplay} />
                                </Chip>
                                <Chip
                                    id="110044"
                                    type="struct"
                                    title="视频专题"
                                    groupName="人在凤凰"
                                    content={rightFive}>
                                    <RightFive show={fiveDisplay} />
                                </Chip>
                            </div>
                        </div>
                    </div>
                    <Footer />
                    <Qrcode content={qrCodeInfo} />
                    <ChipEdit />
                </div>
            );
        }
    },
);

export { Layout };
export default Layout;
